<template>
  <div id="app">
    <Header></Header>
    <div class="app_content">
 <router-view/>
    </div> 
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style scoped>
.app_content{
  min-height: 70vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue